// routes/productRoutes.js
import { lazy } from 'react';

// Lazy load Product pages
const ProductList = lazy(() => import('../pages/product/ProductList'));
const ProductDetails = lazy(() => import('../pages/product/ProductDetails'));

export const productRoutes = [
  { path: '/products', element: <ProductList /> },
  { path: '/products/:id', element: <ProductDetails /> },
];
